/**
 * Known widget codes consumed by tenant main dashboard (GET /api/tenant/dashboard/summary).
 * Custom codes still render as a generic placeholder card.
 */
export const TENANT_MAIN_DASHBOARD_TYPE = 'tenant_main';

export const TENANT_MAIN_WIDGET_PRESETS = [
  { code: 'stat_active_users', name: 'Active users', hint: 'Uses counts.activeUsers from dashboard summary' },
  { code: 'stat_roles', name: 'Roles', hint: 'Uses counts.roles' },
  { code: 'stat_tenant_status', name: 'Tenant status', hint: 'Uses tenant.status from summary' }
];

/**
 * KPI strip on platform analytics (summary.kpis).
 */
export const PLATFORM_ANALYTICS_DASHBOARD_TYPE = 'platform_analytics';

export const PLATFORM_ANALYTICS_KPI_PRESETS = [
  { code: 'kpi_tenant_count', name: 'Tenants', hint: 'kpis.tenantCount' },
  { code: 'kpi_active_tenants', name: 'Active tenants', hint: 'kpis.activeTenants' },
  { code: 'kpi_tenant_users', name: 'Tenant users', hint: 'kpis.totalTenantUsers' },
  { code: 'kpi_api_requests', name: 'API requests', hint: 'kpis.tenantApiRequestsInRange' },
  { code: 'kpi_logins_range', name: 'Logins (range)', hint: 'kpis.loginsInRange' },
  { code: 'kpi_distinct_users_login', name: 'Distinct users w/ login', hint: 'kpis.distinctTenantUsersWithLoginInRange' },
  { code: 'kpi_proctoring_violations', name: 'Violations (all time)', hint: 'kpis.proctoringViolationsTotal' },
  { code: 'kpi_proctoring_snapshots', name: 'Snapshots (all time)', hint: 'kpis.proctoringSnapshotsTotal' }
];
